import styled from '@emotion/styled';

import { MEDIA_QUERY, theme } from 'theme';

export const DisplaySettingsMain = styled.div`
  display: flex;
  height: auto;
  min-height: 100vh;
  max-height: 100vh;
  overflow-y: hidden;
  align-items: stretch;

  @media ${MEDIA_QUERY.MAX_MD} {
    height: 100%;
    min-height: unset;
    max-height: unset;
  }
`;

export const DisplaySettingsSidebar = styled.div`
  min-width: 330px;
  width: 330px;
  min-height: 100vh;
  background: ${theme.colors.black};
  overflow-y: scroll;

  @media ${MEDIA_QUERY.MAX_MD} {
    width: 100%;
  }
`;

export const DisplaySettingsFieldSection = styled.div`
  padding: 30px 53px;
  border-bottom: 1px solid ${theme.colors.mineShaftLighter};

  &:last-child {
    border-bottom: none;
  }

  & > div:nth-child(odd):not(:first-child) {
    margin-top: 20px;
  }
`;

export const DisplaySettingsFieldSectionTitle = styled.div`
  font-size: 12px;
  font-weight: 700;
  color: ${theme.fontColor};
  margin: 0 0 20px 0;
`;

export const DisplaySettingsFieldButtons = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 16px;
`;

export const DisplaySettingsTitle = styled.div`
  background: ${theme.colors.black};
  height: 108px;
  padding: 0 45px;
  display: flex;
  align-items: center;
`;

export const DisplaySettingsMockupContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  flex-grow: 1;

  @media ${MEDIA_QUERY.MAX_MD} {
    display: none;
  }

  & > div {
    max-width: 480px;
  }
`;
